<template>
    <div style="height: 100%">
        <el-container style="height: 100%">
            <el-header
                class="header"
                style="
                    display: flex;
                    flex-direction: row;
                    height: 120px;
                    width: 100%;
                    padding: 40px;
                "
            >
                <div
                    class="el-card box-card is-always-shadow"
                    style="
                        display: inline;
                        height: 100%;
                        padding: 20px;
                        width: 100%;
                    "
                >
                    <div @click="$router.back()">
                        <img
                            src="./img/icon.png"
                            style="height: 40px; float: left; width: 335px"
                        />
                    </div>
                    <ul class="navigation" style="float: left">
                        <el-upload
                            :on-success="uploadExcel"
                            :action="baseUrl + 'transfer'"
                            accept="xlsx"
                            :auto-upload="true"
                            :show-file-list="false"
                        >
                            <li>
                                <i class="el-icon-folder-opened"></i>
                                <span>导入</span>
                            </li>
                        </el-upload>
                        <li @click="exportFile">
                            <i class="el-icon-document-add"></i>
                            <span>导出</span>
                        </li>
                        <li style="width: 1px; background: black"></li>
                        <li @click="roomRelationVisable = true">
                            <i class="el-icon-attract"></i>
                            <span>邻接关系</span>
                        </li>
                        <li @click="pathRelationVisable = true">
                            <i class="el-icon-s-grid"></i>
                            <span>可选过道</span>
                        </li>
                        <li @click="openEvaluate()">
                            <i class="el-icon-s-data"></i>
                            <span>评价</span>
                        </li>
                        <li @click="preview()">
                            <i class="el-icon-orange"></i>
                            <span>预览/计算</span>
                        </li>
                    </ul>
                    <div style="float: right">
                        <div class="header_right">
                            <el-checkbox v-model="markVisable"
                                >显示/隐藏尺寸</el-checkbox
                            >
                            <span class="text">最小单位</span>
                            <el-input
                                size="mini"
                                style="max-width: 130px"
                                v-model="adsorbRate"
                                ><template slot="append">px</template>
                            </el-input>
                        </div>
                        <div class="header_right">
                            <el-checkbox v-model="markLocationVisable"
                                >显示/隐藏坐标</el-checkbox
                            >
                            <span class="text">比例</span>
                            <el-input
                                size="mini"
                                style="max-width: 130px"
                                v-model="lengthRate"
                                ><template slot="append">mm/px</template>
                            </el-input>
                        </div>
                    </div>
                </div>
            </el-header>
            <el-main style="padding: 0 20px">
                <el-container style="height: 100%">
                    <el-aside
                        style="
                            width: 400px;
                            padding: 20px;
                            height: 100%;
                            overflow: hidden;
                        "
                    >
                        <el-tabs
                            v-model="selectedTab"
                            type="border-card"
                            style="height: 100%"
                        >
                            <el-tab-pane label="环境对象" name="env">
                                <el-row>
                                    <el-col
                                        v-for="(item, i) in entities"
                                        :key="i"
                                        :span="6"
                                    >
                                        <el-checkbox
                                            :disabled="
                                                item.checked &&
                                                item.form_type == 1
                                            "
                                            v-model="item.checked"
                                            @change="checkboxChange(item, 0)"
                                            >{{ item.name }}
                                        </el-checkbox>
                                    </el-col>
                                </el-row>
                                <el-collapse v-model="activePanel" accordion>
                                    <template v-for="(item, i) in entities">
                                        <el-collapse-item
                                            v-if="
                                                item.checked &&
                                                item.form_type == 0
                                            "
                                            :key="i"
                                            :title="item.name"
                                            :name="item.type"
                                            style="
                                                padding-left: 20px;
                                                padding-right: 20px;
                                            "
                                        >
                                            <rect-form
                                                :rooms="rooms"
                                                :boundary="boundary"
                                                :lengthRate="lengthRate"
                                                :type="item.type"
                                                :pointVisable="false"
                                                @setTop="setTop"
                                                @setBottom="setBottom"
                                                @choose="chooseRoom"
                                                @choosePoint="choosePoint"
                                                @remove="removeRoom"
                                            >
                                            </rect-form>
                                        </el-collapse-item>
                                    </template>
                                </el-collapse>
                            </el-tab-pane>
                            <el-tab-pane label="生成对象" name="gen">
                                <el-row>
                                    <el-col
                                        v-for="(item, i) in entities"
                                        :key="i"
                                        :span="6"
                                    >
                                        <el-checkbox
                                            :disabled="
                                                item.checked &&
                                                item.form_type == 0
                                            "
                                            v-model="item.checked"
                                            @change="checkboxChange(item, 1)"
                                            >{{ item.name }}
                                        </el-checkbox>
                                    </el-col>
                                </el-row>
                                <el-collapse v-model="activePanel" accordion>
                                    <template v-for="(item, i) in entities">
                                        <el-collapse-item
                                            v-if="
                                                item.checked &&
                                                item.form_type == 1
                                            "
                                            :key="i"
                                            :title="item.name"
                                            :name="item.type"
                                            style="
                                                padding-left: 20px;
                                                padding-right: 20px;
                                            "
                                        >
                                            <rect-form
                                                :rooms="rooms"
                                                :boundary="boundary"
                                                :lengthRate="lengthRate"
                                                :type="item.type"
                                                :pointVisable="false"
                                                @choose="chooseRoom"
                                                @choosePoint="choosePoint"
                                                @remove="removeRoom"
                                            >
                                            </rect-form>
                                        </el-collapse-item>
                                    </template>
                                </el-collapse>
                            </el-tab-pane>
                        </el-tabs>
                    </el-aside>
                    <el-main>
                        <div
                            style="inline;width:100%;height: 100%;  background-size: 20px 20px,20px 20px;
    background-image: linear-gradient(rgba(0,0,0,.1) 1px,transparent 0),linear-gradient(90deg,rgba(0,0,0,.1) 1px,transparent 0);"
                            @mousedown="setActive(false)"
                        >
                            <div
                                style="
                                    display: inline;
                                    width: 100%;
                                    position: relative;
                                    height: 100%;
                                    left: -10px;
                                    top: -10px;
                                "
                            >
                                <rect-item
                                    v-for="(item, i) in rooms"
                                    :lengthRate="lengthRate"
                                    :markVisable="markVisable"
                                    :markLocationVisable="markLocationVisable"
                                    :key="i"
                                    :index="i"
                                    :data="item"
                                    ref="rectItems"
                                    :boundary="boundary"
                                    @rectChange="rectChange"
                                    @focus="(p) => (activePanel = p)"
                                >
                                </rect-item>
                            </div>
                        </div>
                    </el-main>
                </el-container>
            </el-main>
        </el-container>
        <el-dialog
            title="邻接关系"
            class="container"
            width="80%"
            :visible.sync="roomRelationVisable"
        >
            <el-row :gutter="5">
                <el-col :span="2">--</el-col>
                <template v-for="(item, i) in entities">
                    <el-col :key="i" v-if="item.checked" :span="1">{{
                        dic_types[item.type]
                    }}</el-col>
                </template>
            </el-row>
            <template v-for="(item, i) in entities">
                <el-row
                    :gutter="5"
                    v-if="item.checked && item.form_type == 1"
                    :key="i"
                >
                    <el-col :span="2">{{ dic_types[item.type] }}</el-col>
                    <template v-for="(arg, j) in entities">
                        <el-col v-if="arg.checked" :key="j" :span="1">
                            <SwitchButton
                                :dic="roomRelation"
                                :k="item.type + arg.type"
                                @change="
                                    (p) => {
                                        roomRelation[item.type + arg.type] = p;
                                    }
                                "
                            ></SwitchButton>
                            <!-- <el-input v-model="roomRelation[item.type + arg.type]" size="mini"></el-input> -->
                        </el-col>
                    </template>
                </el-row>
            </template>
        </el-dialog>
        <el-dialog
            title="可选过道"
            class="container"
            width="80%"
            :visible.sync="pathRelationVisable"
        >
            <el-row :gutter="5">
                <el-col :span="2">--</el-col>
                <template v-for="(item, i) in entities">
                    <el-col :key="i" v-if="item.checked" :span="1">{{
                        dic_types[item.type]
                    }}</el-col>
                </template>
            </el-row>
            <el-row
                :gutter="5"
                v-for="item in ['living', 'dinner']"
                :key="item"
            >
                <el-col :span="2">{{ dic_types[item] }}</el-col>
                <template v-for="(arg, j) in entities">
                    <el-col v-if="arg.checked" :key="j" :span="1">
                        <SwitchButton
                            :dic="pathRelation"
                            :k="item + arg.type"
                            @change="
                                (p) => {
                                    pathRelation[item + arg.type] = p;
                                }
                            "
                        ></SwitchButton>
                        <!-- <el-input v-model="pathRelation[item + arg.type]" size="mini"></el-input> -->
                    </el-col>
                </template>
            </el-row>
        </el-dialog>
        <el-dialog
            title="评价"
            width="80%"
            top="5vh"
            :visible.sync="evaluateVisable"
        >
            <el-row>
                <!-- <el-col :span="8" class="vert-split-line">
                    <CaseView
                        v-if="$route.params.id.indexOf('_') > 0"
                        style="width: 190px; height: 260px; margin: auto"
                        :data="serverData"
                        :height="260"
                        :width="190"
                    >
                    </CaseView>
                    <DesignerView
                        v-if="$route.params.id.indexOf('_') < 0"
                        style="width: 190px; height: 260px; margin: auto"
                        :data="serverData"
                        :height="260"
                        :width="190"
                    >
                    </DesignerView>
                </el-col> -->
                <el-col :span="24" class="vert-split-line">
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column label="--" prop="name">
                        </el-table-column>
                        <el-table-column
                            :prop="item.type"
                            v-for="item in postData"
                            :key="item.type"
                            :label="dic_types[item.type]"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <div class="chart-container" ref="score"></div>
                    <div class="chart-container" ref="out_all"></div>
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog title="预览" width="1024px" :visible.sync="previewVisable">
            <el-container>
                <el-main>
                    <el-form label-width="80px" :inline="true">
                        <el-form-item label="项目名称">
                            <el-input
                                v-model="config.name"
                                placeholder="请输入名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="算法">
                            <el-select
                                v-model="config.mcts"
                                placeholder="请选择算法"
                            >
                                <el-option label="MCTS算法" value="1">
                                </el-option>
                                <el-option label="PSO-MCTS" value="2">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="性能">
                            <el-select
                                v-model="config.mcts"
                                placeholder="请选择性能"
                            >
                                <el-option label="高性能" value="1">
                                </el-option>
                                <el-option label="均衡" value="2"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="upload"
                                >计算</el-button
                            >
                        </el-form-item>
                    </el-form>
                    <el-table :data="postData" style="width: 100%">
                        <el-table-column prop="" label="名称">
                            <template slot-scope="scope">
                                <span>{{ dic_types[scope.row.type] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="坐标">
                            <template slot-scope="scope">
                                <span v-if="scope.row.form_type == 0">{{
                                    scope.row.left + "," + scope.row.top
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="约束点">
                            <template slot-scope="scope">
                                <span v-if="scope.row.form_type == 1">{{
                                    scope.row.point_x + "," + scope.row.point_y
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="宽度">
                            <template slot-scope="scope">
                                <span v-if="scope.row.form_type == 0"
                                    >{{ scope.row.width }}mm</span
                                >
                                <span v-if="scope.row.form_type == 1"
                                    >{{
                                        scope.row.min_width +
                                        "-" +
                                        scope.row.max_width
                                    }}mm</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="深度">
                            <template slot-scope="scope">
                                <span v-if="scope.row.form_type == 0"
                                    >{{ scope.row.height }}mm</span
                                >
                                <span v-if="scope.row.form_type == 1"
                                    >{{
                                        scope.row.min_height +
                                        "-" +
                                        scope.row.max_height
                                    }}mm</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="面积">
                            <template slot-scope="scope">
                                <span v-if="scope.row.form_type == 1"
                                    >{{
                                        scope.row.min_area +
                                        "-" +
                                        scope.row.max_area
                                    }}m^2</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column prop="count" label="采样次数">
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.count"
                                    @change="
                                        countChange(scope.$index, scope.row)
                                    "
                                    size="mini"
                                >
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="count" label="布置顺序">
                            <template slot-scope="scope">
                                <span v-if="scope.row.form_type == 1">{{
                                    scope.row.order
                                }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
                <el-footer> </el-footer>
            </el-container>
        </el-dialog>
    </div>
</template>
<script>
import {
    colors,
    entities,
    default_path_relation,
    default_room_relation,
    default_room_count,
    dic_types,
    commit_rooms,
    default_rooms,
} from "./api/options";
import RectItem from "./components/rect-item";
import RectForm from "./components/rect-form";
import SwitchButton from "./components/switch-button";
import axios from "axios";
import { baseUrl } from "./config/baseUrl";
import DesignerView from "./components/DesignerView.vue";
import CaseView from "./components/CaseView.vue";
export default {
    name: "WorkSpace",
    components: {
        RectItem,
        RectForm,
        // DesignerView,
        // CaseView,
        SwitchButton,
    },
    data() {
        return {
            baseUrl: baseUrl,
            basic_info: {},
            selectedTab: "env",
            dic_types: dic_types,
            adsorbRate: 10,
            lengthRate: 30,
            toolBoxVisable: false,
            entities: entities,
            pathRelation: {},
            roomRelation: {},
            rooms: [],
            postData: [],
            chooseIndex: null,
            chooseVisable: false,
            obj: {
                width: 5,
                height: 5,
                left: 100,
                top: 100,
            },
            markVisable: false, //矩形中的标尺是否显示
            markLocationVisable: false, //矩形中的坐标是否显示
            roomRelationVisable: false,
            pathRelationVisable: false,
            previewVisable: false,
            evaluateVisable: false,
            boundary: {},
            config: {
                mcts: "1",
                perf: "1",
                name: "",
            },
            serverData: {},
            tableData: null,
            activePanel: "",
        };
    },
    async created() {
        if (this.$route.params.id == 0) {
            this.addRoomCallBack("boundary", 0);
            this.addRoomCallBack("entrance", 0);
            for (let i of entities) {
                for (let j of entities) {
                    let key = i.type + j.type;
                    if (key in default_room_relation) {
                        this.roomRelation[key] = default_room_relation[key];
                    } else this.roomRelation[key] = "0";
                }
            }
            for (let i of ["living", "dinner"]) {
                for (let j of entities) {
                    let key = i + j.type;
                    if (key in default_path_relation) {
                        this.pathRelation[key] = default_path_relation[key];
                    } else this.pathRelation[key] = "0";
                }
            }
        } else {
            if (this.$route.params.id.indexOf("_") >= 0) {
                let data = await axios.post(
                    `${baseUrl}/design/case_base/find?id=` +
                        this.$route.params.id.split("_")[1],
                    {}
                );
                data = data.data.data;
                this.serverData = data;
                this.serverData.room_info = data.data_frame;
                let rooms = JSON.parse(data.json_data);
                this.entities = rooms.entities;
                this.entities.filter((e) => {
                    if (e.checked) e.form_type = 0;
                });
                commit_rooms(rooms.rooms, []);
                this.rooms = rooms.rooms;
                this.pathRelation = rooms.pathRelation;
                this.roomRelation = rooms.roomRelation;
                this.updateBoundary();
            } else {
                let data = await axios.post(
                    `${baseUrl}/design/design/find?id=` + this.$route.params.id,
                    {}
                );
                data = data.data.data;
                this.serverData = data;
                let rooms = JSON.parse(data.data);
                this.entities = rooms.entities;
                this.entities.filter((e) => {
                    if (e.checked) e.form_type = 0;
                });
                commit_rooms(rooms.rooms, JSON.parse(data.room_info));
                this.rooms = rooms.rooms;
                this.pathRelation = rooms.pathRelation;
                this.roomRelation = rooms.roomRelation;
                this.updateBoundary();
            }
        }
    },
    methods: {
        button_change(p) {
            console.log("djksakldsa", p);
        },
        uploadExcel(response) {
            let data = response.data;
            this.roomRelation = data.roomRelation;
            this.pathRelation = data.pathRelation;
            this.entities = data.entities;
            for (let i of data.rooms) {
                i.top = i.top / this.lengthRate;
                i.left = i.left / this.lengthRate;
                i.width = i.width / this.lengthRate;
                i.height = i.height / this.lengthRate;
            }
            let boundary = data.rooms.filter((i) => {
                return i["type"] == "boundary";
            });
            boundary = boundary[0];
            for (let i of data.rooms) {
                if (i.type != "boundary") {
                    i.top = boundary.height - i.height - i.top;
                }
            }
            for (let i of data.rooms) {
                i.top += 200;
                i.left += 200;
            }
            this.rooms = data.rooms;
            this.updateBoundary();
        },
        async openEvaluate() {
            if (!this.basic_info) {
                this.$message({
                    message: "请在计算完成后再查看",
                    type: "error",
                });
                return;
            }
            this.tableData = [];
            this.preview(false);
            let names = { left: "x", top: "y", width: "w", height: "d" };
            let arr = ["left", "top", "width", "height"];
            arr.forEach((i) => {
                let obj = { name: names[i] };
                this.postData.forEach((j) => {
                    obj[j["type"]] = j[i];
                });
                this.tableData.push(obj);
            });
            this.evaluateVisable = true;
            // this.basic_info = JSON.parse(this.serverData.basic_info);
            // let tmp = JSON.parse(this.serverData.energy_load);
            // this.basic_info['供暖-制冷负荷'] = tmp['供暖-制冷负荷'];
            let tmp = {};
            if (this.serverData.room_info)
                tmp = JSON.parse(this.serverData.room_info);

            for (let i of this.rooms) {
                if (!(i.type in tmp)) {
                    tmp[i.type] = {};
                }
                tmp[i.type].center_x =
                    (i.left - this.boundary.left) * this.lengthRate;
                tmp[i.type].center_y =
                    (this.boundary.top +
                        this.boundary.height -
                        (i.top + i.height)) *
                    this.lengthRate;
                tmp[i.type].depth = i.height * this.lengthRate;
                tmp[i.type].width = i.width * this.lengthRate;
            }
            let target = {};
            this.rooms
                .filter((i) => {
                    return i.type in tmp;
                })
                .forEach((e) => {
                    target[e.type] = tmp[e.type];
                });
            let scores = await axios.post(`${baseUrl}scores`, target);
            scores = scores.data.data;
            let x1 = [],
                y1 = [],
                x2 = [],
                y2 = [];
            var getRandomColor = function (key) {
                var dic = {
                    分区: "#6483A6",
                    套型: "#F3A169",
                    总分: "yellow",
                    房间: "#FFE27D",
                    投票: "lightgray",
                    流线: "#C5D5AE",
                    采光主: "#90A8AE",
                    采光次: "lightgray",
                    "K-R分区指标": "#6483A6",
                    "LD-R分区指标": "#6483A6",
                    "LD-T分区指标": "#6483A6",
                    单位面积房间数: "#F3A169",
                    户型通透性: "#F3A169",
                    房间朝向主: "#90A8AE",
                    房间朝向次: "lightgray",
                    房间进深指标: "#FFE27D",
                    房间采光宽度主: "#90A8AE",
                    房间采光宽度次: "lightgray",
                    房间采光深度主: "#90A8AE",
                    房间采光深度次: "lightgray",
                    房间面宽指标: "#FFE27D",
                    房间面积指标: "#FFE27D",
                    过道复杂度: "#C5D5AE",
                    过道面积占比: "#C5D5AE",
                    面宽进深比: "#F3A169",
                };
                return dic[key];
            };
            for (let i of scores.out_all) {
                x1.push(i["name"]);
                y1.push({
                    value: i["value"].toFixed(2),
                    itemStyle: {
                        color: getRandomColor(i["name"]),
                    },
                });
            }
            for (let i of scores.out_merge) {
                console.log("out_merge", i);
                x2.push(i["name"]);
                y2.push({
                    value: i["value"].toFixed(2),
                    itemStyle: {
                        color: getRandomColor(i["name"]),
                    },
                });
            }
            let option1 = {
                xAxis: {
                    type: "category",
                    name: "维度",
                    data: x1,
                    axisLabel: {
                        interval: 0,
                        rotate: 40,
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{b} <br/>{c}",
                },
                yAxis: {
                    type: "value",
                    name: "得分",
                },
                series: [
                    {
                        data: y1,
                        type: "bar",
                    },
                ],
            };
            let option2 = {
                xAxis: {
                    type: "category",
                    name: "维度",
                    data: x2,
                    axisLabel: {
                        interval: 0,
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{b} <br/>{c}",
                },
                yAxis: {
                    type: "value",
                    name: "得分",
                },
                series: [
                    {
                        data: y2,
                        type: "bar",
                    },
                ],
            };
            setTimeout(() => {
                var charts1 = this.$echarts.init(this.$refs.out_all);
                charts1.setOption(option1);
                var charts2 = this.$echarts.init(this.$refs.score);
                charts2.setOption(option2);
            });
        },
        checkboxChange(item, form_type) {
            if (item.checked) {
                item.form_type = form_type;
                this.addRoomCallBack(item.type, form_type);
            } else {
                for (let i = 0; i < this.rooms.length; i++) {
                    if (this.rooms[i].type == item.type) {
                        this.rooms.splice(i, 1);
                    }
                }
                for (let i = 0; i < this.entities.length; i++) {
                    if (this.entities[i].type == item.type) {
                        this.entities[i].form_type = null;
                    }
                }
            }
        },
        countChange(p, p2) {
            for (let i of this.rooms) {
                if (i["type"] == p2.type) {
                    i["count"] = p2.count;
                    break;
                }
            }
        },
        rectChange(index, left, top, width, height) {
            if (this.rooms[index].form_type == 0) {
                this.rooms[index].left = this.round(left, this.adsorbRate);
                this.rooms[index].top = this.round(top, this.adsorbRate);
                this.rooms[index].width = this.round(width, this.adsorbRate);
                this.rooms[index].height = this.round(height, this.adsorbRate);
            } else {
                if (!this.boundary.left) {
                    this.$message({
                        message: "请先添加边界",
                        type: "error",
                    });
                    return;
                }
                this.rooms[index].point_x =
                    (this.round(left, this.adsorbRate) - this.boundary.left) *
                    this.lengthRate;
                this.rooms[index].point_y =
                    (this.boundary.top +
                        this.boundary.height -
                        this.round(top, this.adsorbRate)) *
                    this.lengthRate;
                this.chooseVisable = false;
                this.rooms[index].width = 10;
                this.rooms[index].height = 10;
            }
            this.updateBoundary();
        },
        addRoomCallBack(type, form_type) {
            let width = 100;
            let height = 100;
            let room = {
                type: type,
                form_type: form_type,
                left: 0,
                top: 0,
                width: width,
                height: height,
                point_x: -1,
                point_y: -1,
                min_width: 0,
                max_width: 0,
                min_height: 0,
                max_height: 0,
                min_area: 0,
                max_area: 0,
                point_visable: false,
                count: default_room_count[type],
            };
            if (form_type == 1) {
                width = 0;
                height = 0;
                let res = default_rooms.filter((i) => {
                    if (i.type == type) return i;
                });
                if (res && res.length > 0) {
                    room = res[0];
                    room.form_type = 1;
                }
            }
            this.rooms.push(room);
            this.updateBoundary();
        },
        updateBoundary() {
            let tmp = this.rooms.filter((e) => {
                if (e.type == "boundary") return true;
            });
            if (tmp) {
                tmp = tmp[0];
                for (let i in tmp) {
                    this.boundary[i] = tmp[i];
                }
            }
        },
        setTop(item) {
            let index = this.rooms.indexOf(item);
            let tmp = this.rooms
                .slice(0, index)
                .concat(this.rooms.slice(index + 1, this.rooms.length))
                .concat([item]);
            this.rooms = [];
            setTimeout(() => {
                this.rooms = tmp;
            });
        },
        setBottom(item) {
            let index = this.rooms.indexOf(item);
            let tmp = [item].concat(
                this.rooms
                    .slice(0, index)
                    .concat(this.rooms.slice(index + 1, this.rooms.length))
            );
            this.rooms = [];
            setTimeout(() => {
                this.rooms = tmp;
            });
        },
        chooseRoom(item) {
            // this.rooms.this.setActive(false);
            // this.$refs.rectItems[this.rooms.indexOf(item)].setActive(true);
        },
        removeRoom(item) {
            for (let i = 0; i < this.entities.length; i++) {
                if (item.type == this.entities[i].type) {
                    this.entities[i].checked = false;
                    this.entities[i].form_type = null;
                }
            }
            this.rooms.splice(this.rooms.indexOf(item), 1);
        },
        setActive(act = false) {
            if (this.$refs.rectItems)
                for (let i of this.$refs.rectItems) {
                    i.setActive(act);
                }
        },
        choosePoint(item) {
            this.chooseIndex = this.rooms.indexOf(item);
            this.chooseVisable = true;
            this.setActive();
            this.$refs.rectItems[this.chooseIndex].setActive(true);
            setTimeout(() => {
                this.$refs.point.setActive(true);
            });
        },
        round(num, ratio = 10) {
            return Math.round(num / ratio) * ratio;
        },
        chooseEnd({ index, left, top, width, height }) {},
        async exportFile() {
            this.postData = JSON.parse(JSON.stringify(this.rooms));
            this.postData.filter((e) => {
                if (e.left) {
                    e.left *= this.lengthRate;
                    e.top *= this.lengthRate;
                    e.width *= this.lengthRate;
                    e.height *= this.lengthRate;
                }
                if (e.point_x) {
                    e.point_x = parseInt(e.point_x);
                    e.point_y = parseInt(e.point_y);
                }
            });
            let boundary = null;
            this.postData.filter((e) => {
                if (e.type == "boundary") boundary = e;
            });
            let offsetX = boundary["left"];
            let offsetY = boundary["top"] + boundary["height"];
            this.postData.filter((e) => {
                if (e.left) {
                    e.left = e.left - offsetX;
                    e.top = offsetY - (e.top + e.height);
                }
            });
            let room_sort = {
                white_m1: 0,
                white_m2: 1,
                white_m3: 2,
                white_m4: 3,
                living: 4,
                room1: 5,
                room2: 6,
                room3: 7,
                room4: 8,
                kitchen: 9,
                toilet_main: 10,
                toilet2: 11,
                hallway: 12,
                dinner: 13,
            };
            let orders = this.postData.filter((i) => {
                if (i.form_type == 1) return i.type;
            });
            orders.sort((a, b) => {
                return room_sort[a.type] - room_sort[b.type];
            });
            for (let i = 0; i < orders.length; i++) {
                orders[i].order = i + 1;
            }
            let data = {};
            data.config = this.config;
            data.roomRelation = this.roomRelation;
            data.pathRelation = this.pathRelation;
            data.entities = this.entities;
            data.rooms = this.postData;
            let res = await axios.post(`${baseUrl}/design/design/export`, {
                data: data,
            });
            window.location.href = `${baseUrl}${res.data.data}`;
        },
        async importFile() {
            let [fileHandle] = await window.showOpenFilePicker({
                multiple: false,
            });
            const file = await fileHandle.getFile();
            const contents = await file.text();
            let data = JSON.parse(contents);
            this.roomRelation = data.roomRelation;
            this.pathRelation = data.pathRelation;
            this.entities = data.entities;
            this.rooms = data.rooms;
            this.updateBoundary();
        },
        preview(is_show = true) {
            this.postData = JSON.parse(JSON.stringify(this.rooms));
            this.postData.filter((e) => {
                if (e.left) {
                    e.left *= this.lengthRate;
                    e.top *= this.lengthRate;
                    e.width *= this.lengthRate;
                    e.height *= this.lengthRate;
                }
                if (e.point_x) {
                    e.point_x = parseInt(e.point_x);
                    e.point_y = parseInt(e.point_y);
                }
            });
            let boundary = null;
            this.postData.filter((e) => {
                if (e.type == "boundary") boundary = e;
            });
            if (!boundary) {
                this.$message({
                    message: "未添加边界",
                    type: "success",
                });
                return;
            }
            let offsetX = boundary["left"];
            let offsetY = boundary["top"] + boundary["height"];
            this.postData.filter((e) => {
                if (e.left) {
                    e.left = e.left - offsetX;
                    e.top = offsetY - (e.top + e.height);
                }
            });
            let room_sort = {
                white_m1: 0,
                white_m2: 1,
                white_m3: 2,
                white_m4: 3,
                living: 4,
                room1: 5,
                room2: 6,
                room3: 7,
                room4: 8,
                kitchen: 9,
                toilet_main: 10,
                toilet2: 11,
                hallway: 12,
                dinner: 13,
            };
            let orders = this.postData.filter((i) => {
                if (i.form_type == 1) return i.type;
            });
            orders.sort((a, b) => {
                return room_sort[a.type] - room_sort[b.type];
            });
            for (let i = 0; i < orders.length; i++) {
                orders[i].order = i + 1;
            }
            this.previewVisable = is_show;
        },
        async upload() {
            if (!this.config.name) {
                this.$message({
                    message: "请输入名称",
                    type: "error",
                });
                return;
            }
            let data = {};
            data.config = this.config;
            data.roomRelation = this.roomRelation;
            data.pathRelation = this.pathRelation;
            data.entities = this.entities;
            data.rooms = this.postData;

            let res = await axios.post(`${baseUrl}/design/design/upload`, data);
            if (res.data.status == 200) {
                this.$message({
                    message: res.data.message,
                    type: "success",
                });
            }
        },
    },
};
</script>
<style >
body {
    background-color: aliceblue;
    margin: 0px;
}

body,
html,
#app {
    height: 100%;
}

.avue-draggable__line--label {
    display: none;
}

.el-collapse-item:hover .el-collapse-item__arrow .el-icon-arrow-right {
    color: skyblue;
}

.el-col {
    margin-bottom: 10px;
}

.navigation {
    display: flex;
    flex-direction: row;
    padding: 0;
    margin: 0;
}

.navigation li {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    width: 100px;
    font-size: 14px;
}

.navigation li span:hover {
    color: #000;
}

.navigation li i {
    width: 18px;
    height: 18px;
    font-size: 18px;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header_right {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header_right .text {
    color: #606266;
    font-size: 12px;
    width: 100px;
    margin: 0px;
    margin-left: 10px;
}

.header_right .el-checkbox__label {
    font-size: 12px;
}

.header_right input {
    height: 20px !important;
    line-height: 20px !important;
}

.container .el-row {
    display: flex;
}

.el-input__inner {
    padding: 0 5px !important;
    text-align: center;
}

.chart-container {
    height: 250px;
}

.el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.el-tabs__content {
    overflow: auto !important;
}
</style>
